<template>
<div id="user-profile">

    <div id="showPhoto">
              <v-layout row justify-center>
    <v-dialog v-model="showPict" persistent max-width="670">
      <v-card>
        <v-card-title class="headline">{{'emp._photo_'|translate}}{this.signinUser.firstName}}</v-card-title>
        <v-card-text><img v-bind:src="signinUser.imageUrl"/></v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat @click.native="showPict = false">{{'general._close_'|translate}}</v-btn>
          <v-btn color="green darken-1" flat @click.native="takePhoto">{{'general._change_photo_'|translate}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
          </div>

   <v-container fluid grid-list-xl>
    <v-layout wrap align-center>
      <v-flex xs12>
  <v-toolbar>
     <v-toolbar-title>
       <v-list-tile>
        <v-list-tile-avatar size="50">
               <img v-on:click="showPict = true" style="cursor: pointer" v-bind:src="signinUser.imageUrl"/>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>{{signinUser.firstName}} {{signinUser.lastName}}</v-list-tile-title>
                <v-list-tile-sub-title>{{'emp._emp_num_'|translate}} : {{ signinUser.employeeNumber }}</v-list-tile-sub-title>
              </v-list-tile-content>
       </v-list-tile>
    </v-toolbar-title>
  </v-toolbar>
  <v-card class="mb-5">
       <v-card-title>
    <form @submit.prevent="validateUser">
      <v-layout row wrap>
      <br>
           <v-flex xs12 sm4>
              <v-text-field 
                 :label="$t('emp._firstname_')"
                name="Prénom" 
                autocomplete="given-name"
                @input="profileChanged = true"
                v-model="signinUser.firstName"
                :disabled="sending">
              </v-text-field>
           </v-flex>

             <v-flex xs12 sm4>
              <v-text-field 
                :label="$t('emp._postname_')"
                name="Poste nom" 
                autocomplete="given-name"
                v-model="signinUser.postName"
                :disabled="sending">
              </v-text-field>
           </v-flex>

           <v-flex xs12 sm4>
              <v-text-field
                :label="$t('emp._lastname_')"
                autocomplete="family-name"
                v-model="signinUser.lastName"
                @input="profileChanged = true"
                :disabled="sending">
              </v-text-field>
           </v-flex>
           <v-flex xs12 sm4>
            <v-text-field
            :label="$t('emp._phone_')"
            v-model="signinUser.phone"
            @input="profileChanged = true"
            required>
          </v-text-field>
           </v-flex>
           <v-flex xs12 sm4>
            <v-text-field
            :label="$t('emp._email_')"
            type="email"
            autocomplete="email"
            @input="profileChanged = true"
            v-model="this.email">
          </v-text-field>
          </v-flex>
              <v-flex xs12 sm4>
        <span class="md-title">{{'emp._acess_level_'|translate}}:</span>
        <v-select
        @input="profileChanged = true"
        solo
        v-model="signinUser.accessLevel"
        required
         :items="[$t('emp._acess_level1_'),$t('emp._acess_level2_'),$t('emp._acess_level3_'),$t('emp._acess_level4_')]"
        >
        </v-select>
          </v-flex>
           <v-flex xs12 sm4>
            <v-autocomplete v-model="signinUser.city" :label="$t('providers._city_')" id="city" :items="areas" required>
              </v-autocomplete>
          </v-flex>
          <v-flex xs12 sm4>           
            <v-autocomplete v-model="signinUser.postalCode" :label="$t('coupons._cop_region_')" :items="zones" required>
              </v-autocomplete>
          </v-flex>
           <v-flex xs12 sm4>
            <v-text-field
            type="text"
            :label="$t('coupons._cop_civic_')"
            v-model="signinUser.address"
            required
            >
          </v-text-field>
            </v-flex>
          <v-flex xs12 sm6>
               <v-text-field
            v-model="newPassword"
            :append-icon="show1 ? 'visibility_off' : 'visibility'"
            :rules="[rules.min]"
            :type="show1 ? 'text' : 'password'"
            name="input-10-2"
            :label="$t('emp._pass_')"
            :hint="$t('emp._pass_val_')"
            @input="profileChanged = true"
            @click:append="show1 = !show1"
          ></v-text-field>
          </v-flex>
            <v-flex xs12 sm6>
            <v-text-field
            v-model="confirmPassword"
            :append-icon="show2 ? 'visibility_off' : 'visibility'"
            :rules="[rules.passwordMatch]"
            :type="show2 ? 'text' : 'password'"
            name="input-10-2"
            :label="$t('emp._conf_pass_')"
            @click:append="show2 = !show2"
          ></v-text-field>
          </v-flex>
        <v-card-actions>
           <v-btn v-on:click="goBack" color="primary">{{'emp._back_'|translate}}</v-btn>
        </v-card-actions>
            <v-spacer></v-spacer>
        <v-card-actions>
          <v-btn type="submit" color="primary">{{'events._Update_'|translate}}</v-btn>
        </v-card-actions>
       
      </v-layout>
    </form>
       </v-card-title>
  </v-card>
      </v-flex>
    </v-layout>
   </v-container>
  </div>
</template>
<script>
/* eslint-disable */
import { db } from '@/api/firebaseInit';
import firebase from 'firebase';
import { communes } from '@/api/communes';
import { quartiers } from '@/api/quartiers';
export default {
  name: 'user-profile',
  data() {
    return {
      accessLevel: null,
      editMode: true,
      showData: false,
      selected: {},
      search: null,
      zones: quartiers,
      areas: communes,
      searched: [],
      employee_id: null,
      employeeNumber: null,
      sending: false,
      access: 'Clerk',
      imageUrl: '/assets/avatar.png',
      showPict: false,
      menu: false,
      profileChanged: false,
      newPassword: '',
      confirmPassword: '',
      entriesDate: null,
      show1: false,
      show2: false,
      rules: {
        required: value => !!value || this.$t('general._req_field_'),
        min: v => v.length >= 8 || this.$t('general._pass_val_'),
        passwordMatch: value =>
          value == this.newPassword ||  this.$t('general._pass_does_notmatch_')
      }
    };
  },
  computed: {
    signinUser() {
      let employee = this.$store.getters.currentEmployee;
      this.employee_id = employee.employeeId;
      return employee;
    },
    email() {
      let email = this.signinUser.firstName + this.signinUser.lastName + "@mosala.work";
      return email
    },
     fullName() {
      let email = this.signinUser.firstName + ' ' + this.signinUser.lastName;
      return email
    }
    // entriesDate: function () {
    //      var today = (new Date()).toString();
    //      today = today.substring(0, 15);
    // }
  },
  watch: {
    signinUser(val) {
      this.$store.commit('currentEmployee', val)
    }
  },
  methods: {
   
    fetchLoginData() {
      db.collection('Employees')
        .doc(this.employee_id)
        .collection('Logs')
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            const data = {
              id: doc.id,
              loginTime: doc.data().loginTime,
              logOutTime: doc.data().logOutTime
            };
            this.members.push(data);
            this.searched = this.members;
          });
        });
    },
    fetchDataEntries() {
      this.members = [];
      db.collection('Employees')
        .doc(this.employee_id)
        .collection('Entries')
        .doc('currentDate')
        .collection('Entries')
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
          });
        });
    },
    save(date) {
      this.$refs.menu.save(date);
    },
    saveEmployee() {
      var googPhone = '+' + this.signinUser.phone;
      if (this.profileChanged) {
        db.collection('Employees')
          .doc(this.employee_id)
          .collection('Profile')
          .doc(this.employee_id)
          .set({
            displayName: this.fullName,
            email: this.email,
            newPassword: this.newPassword,
            phone: googPhone
          })
          .then(() => {
            this.profileChanged = false;
            this.updateEmployee();
          });
      } else {
        this.updateEmployee();
      }
    },
    updateEmployee() {
      db.collection('Employees')
        .doc(this.employee_id)
        .update({
          address: this.signinUser.address,
          city: this.signinUser.city,
          postalCode: this.signinUser.postalCode,
          employeeId: this.employee_id,
          email: this.email,
          accessLevel: this.signinUser.accessLevel,
          firstName: this.signinUser.firstName,
          posteName: this.signinUser.posteName,
          phone: this.signinUser.phone,
          lastName: this.signinUser.lastName
        })
        .then(() => {
          alert(this.$t('emp.saved_succ_'));
        this.$store.commit('', signinUser)
          //   that.goBack()
        })
        .catch(function(error) {
          console.error('Error adding document: ', error);
        });
    },
    validateUser() {
      if (this.signinUser.posteName == null || this.signinUser.posteName == undefined) {
        this.signinUser.posteName = null
      }
      this.saveEmployee();
    },
    goBack() {
      this.$router.go('-1');
    },
    takePhoto() {
      this.$router.push({
        name: 'take-photo',
        params: {
          employee_id: this.signinUser.employee_id
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/modifiers/EmployeeProfile.vue